import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultQprtOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'qprt-overview-page-two-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'qprt-overview-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is a QPRT right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'qprt-overview-page-two-home-value',
              type: 'PresentationListItem',
              props: {
                title: 'Home value',
                description:
                  'A QPRT works best when your residence represents a significant portion of your estate and is expected to continue appreciating, as future appreciation occurs outside your estate.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'qprt-overview-page-two-time-horizon',
              type: 'PresentationListItem',
              props: {
                title: 'Time horizon',
                description:
                  'You must outlive the trust term to realize the tax benefits. If you pass away during the term, the home returns to your taxable estate.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'qprt-overview-page-two-continued-use',
              type: 'PresentationListItem',
              props: {
                title: 'Continued use of the home',
                description:
                  'If you wish to remain in the home after the term, you will need to pay fair market rent to your beneficiaries - though this can serve as an additional way to move money outside of your estate.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'qprt-overview-page-two-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether a QPRT aligns with your overall financial strategy.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
